module.exports = {
      id: "google-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#google",
      toString: function () {
        return this.url;
      }
    }